export default __webpack_public_path__ + "static/media/slider-arrow.c3bddf65.svg";